<template>
  <div class="bg-white rounded-md inline-block relative w-full md:w-[300px] p-4">
    <div class="text-xl font-bold mb-4">
      {{ i18n.t('item.product_added') }}
    </div>
    <a v-if="cartUrl" :href="cartUrl" data-umami-event="View in cart" class="jt-btn my-2">
      {{ i18n.t('item.view_in_cart') }}
    </a>
    <div v-if="accessories.length > 0" class="text-jt-dark-grey opacity-60">
      {{ i18n.t('item.might_be_interested') }}:
    </div>
    <div class="overflow-auto max-h-80">
      <div v-for="item in accessories" :key="item.id" class="flex items-center gap-4 mt-4">
        <img v-if="item.attributes.main_image" :src="item.attributes.main_image" class="object-cover h-12 w-12 rounded-lg" />
          <div v-else class="h-12 w-12 flex items-center justify-center">
            <span class="fa-stack text-[24px] opacity-20">
              <i class="fa-image far fa-stack-1x" aria-hidden="true"></i>
              <i class="fa-slash fas icon-stack-base fa-stack-1x " aria-hidden="true"></i>
            </span>
          </div>
        <div class="flex-grow">
          <a :href="item.attributes.urls.show" class="font-bold text-sm">{{ item.attributes.name }}</a>
          <div class="text-jt-dark-grey opacity-60 text-xs">
            <template v-if="item.attributes.itype == 1">
              {{ item.attributes.duration }}
            </template>
            <template v-if="item.attributes.size">
              {{ item.attributes.size }}
            </template>
             | {{ item.attributes.price }}{{ item.attributes.currency_symbol }} {{ item.attributes.price_unit }}
          </div>
        </div>
        <div class="flex-shrink-0">
          <button class="jt-btn btn-icon ml-auto flex-shrink-0" @click.prevent.stop="bookItem(item.id)">
            <i v-if="itemAddedToCart == item.id" class="fas fa-check"></i>
            <i v-else class="fas fa-plus"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Accessories',
  props: {
    item: Object,
    cart: Object,
  },
  data: function() {
    return {
      accessories: [],
      itemAddedToCart: false
    }
  },
  computed: {
    cartUrl() {
      return this.cart.urls?.checkout
    }
  },
  mounted() {
    this.getAccessories();
  },
  methods: {
    getAccessories() {
      fetch(this.item.attributes.urls.accessories)
        .then(response => response.json())
        .then(data => {
          this.accessories = data.data
        })
    },
    bookItem(id) {
      window.topNavigation?.$refs.topNavigation.updateCart(
        id,
        1
      )
      this.itemAddedToCart = id
      setTimeout(() => {
        this.itemAddedToCart = false
      }, 3000)
    }
  }
}
</script>
